var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          staticClass: "notice",
          attrs: { width: "600", scrollable: "", closable: false },
          on: { "on-visible-change": _vm.cancelHandler },
          model: {
            value: _vm.notice.isShow,
            callback: function($$v) {
              _vm.$set(_vm.notice, "isShow", $$v)
            },
            expression: "notice.isShow"
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
                "align-items": "center",
                "margin-bottom": "25px"
              },
              attrs: { slot: "header" },
              slot: "header"
            },
            [
              _c("div", { staticStyle: { display: "flex" } }, [
                _c(
                  "div",
                  {
                    staticClass: "is_viewed left",
                    class: _vm.is_viewed === false ? "selected" : "",
                    on: {
                      click: function($event) {
                        return _vm.getMessage(false)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("notice_detail.unread") +
                            " (" +
                            (_vm.notice.unread_count || 0) +
                            ")"
                        ) +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "is_viewed right",
                    class: _vm.is_viewed !== false ? "selected" : "",
                    on: {
                      click: function($event) {
                        return _vm.getMessage(true)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("notice_detail.all") +
                            " (" +
                            (_vm.notice.count || 0) +
                            ")"
                        ) +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "all_read",
                    on: { click: _vm.set_all_readed }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("notice_detail.all_read")) +
                        "\n        "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("Icon", {
                staticStyle: { cursor: "pointer" },
                attrs: { size: "20", color: "#fff", type: "md-close" },
                on: {
                  click: function($event) {
                    _vm.notice.isShow = false
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "notice_container" }, [
            _c(
              "div",
              { staticStyle: { height: "431px", position: "relative" } },
              [
                (_vm.is_viewed !== false
                ? _vm.notice.dataList.length > 0
                : _vm.notice.unreadList.length > 0)
                  ? [
                      _c(
                        "div",
                        { staticStyle: { height: "375px" } },
                        _vm._l(
                          _vm.is_viewed !== false
                            ? _vm.notice.dataList
                            : _vm.notice.unreadList,
                          function(message) {
                            return _c(
                              "div",
                              {
                                key: message.notice_id,
                                staticClass: "message"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "info" },
                                  [
                                    !message.is_viewed
                                      ? _c(
                                          "Badge",
                                          {
                                            attrs: { dot: "", offset: [6, 4] }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "message_type",
                                                staticStyle: {
                                                  "flex-shrink": "0"
                                                },
                                                style: {
                                                  color:
                                                    _vm.notice_colors[
                                                      _vm.get_notice_type(
                                                        message
                                                      )
                                                    ]
                                                }
                                              },
                                              [
                                                message.notice_type == 3
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "is_qa" },
                                                      [
                                                        _c("div", {
                                                          staticClass: "qa_text"
                                                        })
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "notice_detail['" +
                                                          _vm.get_notice_type(
                                                            message
                                                          ) +
                                                          "']"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "message_type",
                                            staticStyle: { "flex-shrink": "0" },
                                            style: {
                                              color:
                                                _vm.notice_colors[
                                                  _vm.get_notice_type(message)
                                                ]
                                            }
                                          },
                                          [
                                            message.notice_type == 3
                                              ? _c(
                                                  "div",
                                                  { staticClass: "is_qa" },
                                                  [
                                                    _c("div", {
                                                      staticClass: "qa_text"
                                                    })
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "notice_detail['" +
                                                      _vm.get_notice_type(
                                                        message
                                                      ) +
                                                      "']"
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "text" }, [
                                      _c(
                                        "div",
                                        { staticClass: "message_title" },
                                        [_vm._v(_vm._s(message.title))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "message_time" },
                                        [
                                          message.event_name
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "align-items": "center",
                                                    "max-width":
                                                      "calc(100% - 160px)"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "name one-ellipsis",
                                                      attrs: {
                                                        title:
                                                          "" +
                                                          message.event_name +
                                                          (message.session_name
                                                            ? " / " +
                                                              message.session_name
                                                            : "")
                                                      }
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            message.event_name
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      message.session_name
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                margin: "0 3px"
                                                              }
                                                            },
                                                            [_vm._v(">")]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      message.session_name
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                message.session_name
                                                              )
                                                            )
                                                          ])
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          message.event_name
                                            ? _c("div", {
                                                staticStyle: {
                                                  background:
                                                    "rgb(117, 117, 117)",
                                                  width: "2px",
                                                  height: "14px",
                                                  margin: "0 10px"
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm._f("formatDate")(
                                                    message.due_time
                                                      ? message.due_time
                                                      : message.created_at
                                                  )
                                                ) +
                                                "\n                    "
                                            )
                                          ])
                                        ]
                                      )
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "view",
                                    on: {
                                      click: function($event) {
                                        return _vm.viewNoticeDetail(message)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("notice_detail.view")) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]
                            )
                          }
                        ),
                        0
                      ),
                      _vm._v(" "),
                      _c("Page", {
                        attrs: {
                          "page-size": _vm.notice.getNoticeListParams.page_size,
                          total:
                            _vm.is_viewed !== false
                              ? _vm.notice.count
                              : _vm.notice.unread_count,
                          current: _vm.notice.getNoticeListParams.page_index,
                          size: "small",
                          "show-total": ""
                        },
                        on: { "on-change": _vm.changPage }
                      })
                    ]
                  : [
                      _c("div", { staticClass: "no_event" }, [
                        _c("div", { staticClass: "no_event_img" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "no_event_font" }, [
                          _vm._v(_vm._s(_vm.$t("confirmMsg.no_notice")))
                        ])
                      ])
                    ]
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" })
        ]
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          staticClass: "notice_content",
          attrs: { width: "800px", closable: false },
          on: { "on-visible-change": _vm.cancelHandler },
          model: {
            value: _vm.notice.showContent,
            callback: function($$v) {
              _vm.$set(_vm.notice, "showContent", $$v)
            },
            expression: "notice.showContent"
          }
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "space-between",
                  "align-items": "center"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: { "font-size": "25px", "font-weight": "600" }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.notice.notice_detail.title) +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: { cursor: "pointer" },
                    on: { click: _vm.close_notice_detail }
                  },
                  [_c("Icon", { attrs: { size: "35", type: "ios-close" } })],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "14px",
                  color: "#d9d9d9",
                  "margin-top": "5px"
                }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm._f("formatDate")(_vm.notice.notice_detail.created_at)
                    ) +
                    "\n      "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "notice_container" }, [
            _c("div", { staticClass: "father custom-scroll" }, [
              _c("div", {
                staticClass: "content",
                domProps: {
                  innerHTML: _vm._s(_vm.notice.notice_detail.content)
                },
                on: { click: _vm.previewImgHandler }
              }),
              _vm._v(" "),
              _vm.notice.media_list.length > 0
                ? _c("div", { staticClass: "accessory" }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "margin-top": "50px",
                          "border-radius": "5px 5px 0 0",
                          display: "flex",
                          "align-items": "center",
                          background: "#303030",
                          padding: "5px"
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("../../static/images/link.svg"),
                            alt: ""
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticStyle: { "margin-left": "10px" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t("notice_detail.accessory") +
                                  " ( " +
                                  _vm.notice.media_list.length +
                                  " )"
                              ) +
                              "\n            "
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          padding: "5px",
                          "border-radius": "0 0 5px 5px",
                          background: "#757575"
                        }
                      },
                      _vm._l(_vm.notice.media_list, function(accessory) {
                        return _c(
                          "div",
                          {
                            key: accessory.media_id,
                            staticClass: "accessory_item"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  "font-size": "14px"
                                }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("../../static/images/file.svg"),
                                    alt: ""
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "margin-left": "5px",
                                      "flex-direction": "column",
                                      "justify-content": "space-around"
                                    }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(accessory.media_title))
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "download_accessory",
                                        on: {
                                          click: function($event) {
                                            return _vm.download_accessory(
                                              accessory
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.$t(
                                                "notice_detail.download_accessory"
                                              )
                                            ) +
                                            "\n                  "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-797c0f96", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-797c0f96","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/notice_modal.vue
// module id = null
// module chunks = 